var image_viewer_rtlignore_default = {
  "fontElementMap": "rtxqo",
  "imageContainer": "dVJcp",
  "expandButton": "u8yqh",
  "expandIcon": "rwAk7",
  "pointer": "vpC6d",
  "imageWrapper": "fTBfd",
  "imageRatio": "lSGqL",
  "image": "tfWqy",
  "imageOverlay": "PF26Z",
  "imagePreload": "iapR4",
  "imageHighres": "_1UpMg",
  "onlyHighRes": "Rn5n3",
  "image_loading": "MaWTe"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
